import React from 'react'
import DeptToolsAccordion from './Components/DeptToolsAccordion'
import AddDepartments from './Components/AddDepts'
import AppShell from '../../Components/AppShell'
import PageHeader from '../../Components/PageHeader'

const ManageDepartmentsView = () => {
  return (
    <AppShell>
      <PageHeader
        kicker="Admin"
        title="Departments"
        subtitle="Manage department tools and workspace access."
        crumbs={[
          { label: 'Home', to: '/home' },
          { label: 'Admin', to: '/adminNXS0011/dashboard' },
          { label: 'Departments' },
        ]}
        actions={<AddDepartments />}
      />
      <DeptToolsAccordion />
    </AppShell>
  )
}

export default ManageDepartmentsView
